import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button, Popconfirm,
    Pagination, Popover, Tabs,
} from 'antd';

import {asyncGet, actions, asyncGetUserList, asyncGetTaskInfo, delect, asyncGetMonitorList,asyncGetEvs} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
const TabPane = Tabs.TabPane;
import moment from 'moment';
import {stringToTime} from "../../../utils";
import {Link} from "react-router-dom";



class taskIvt extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetMonitorList();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    edit = (record, type) => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record._id);
    }

    handleDelete = async record => {
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认删除'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.handleDelete(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        删除
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    render() {
        let { list, uiStatus ,pagination} = this.props;
        let { isLoading } = uiStatus;
        const columns = [
            {
                title: 'eid',
                dataIndex: 'eid',
                key: 'eid',
            },
            {
                title: 'taskid',
                dataIndex: 'taskid',
                key: 'taskid',
            },
            {
                title: 'ps',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '时间',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '检测公司',
                dataIndex: 'monitoringName',
                key: 'monitoringName',
            },
            {
                title: 'ipUa2',
                dataIndex: 'ipUa2',
                key: 'ipUa2',
            },
            {
                title: 'ipUa5',
                dataIndex: 'ipUa5',
                key: 'ipUa5',
            },
            {
                title: 'ipUa10',
                dataIndex: 'ipUa10',
                key: 'ipUa10',
            },
            {
                title: 'ipUa30',
                dataIndex: 'ipUa30',
                key: 'ipUa30',
            },
            {
                title: 'ip2',
                dataIndex: 'ip2',
                key: 'ip2',
            },
            {
                title: 'ip5',
                dataIndex: 'ip5',
                key: 'ip5',
            },
            {
                title: 'ip10',
                dataIndex: 'ip10',
                key: 'ip10',
            },
            {
                title: 'ip30',
                dataIndex: 'ip30',
                key: 'ip30',
            },
            ];

        let { totalPage, current, pageSize } = pagination;

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                        defaultExpandAllRows={false}
                    />
                     <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={totalPage}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['10', '15', '20', '40','100','500','1000']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                     </Row>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.taskIvt.list,
    pagination: state.taskIvt.pagination,
    proxyrepeatinfo: state.taskIvt.proxyrepeatinfo,
    uiStatus: state.taskIvt.uiStatus,
    agentsGroup: state.taskIvt.agentsGroup,
    transferData: state.taskIvt.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    asyncGetEvs: () => dispatch(asyncGetEvs()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeSelectTab: text => dispatch(actions.changeUiStatus({ onSelectTab: text })),
    asyncGetTaskInfo: (record, type) => dispatch(asyncGetTaskInfo(record, type)),
    asyncGetUserList: () => dispatch(asyncGetUserList()),
    changePagination: data => dispatch(actions.changePagination(data)),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delect: record => dispatch(delect(record)),
    asyncGetMonitorList: () => dispatch(asyncGetMonitorList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(taskIvt);






// WEBPACK FOOTER //
// ./pages/monitor/taskIvt/index.js